/*! Copyright (C) Microsoft. All rights reserved. */

import { initFeedbackForm, initFeedbackControl } from "./ExtendedFeedback";

$(function () {
	initFeedbackForm();
	initFeedbackControl();
});
